import { Button, Link, Text } from '@factorialco/deprecated-design-system'
import { RevokeDatevLaudsTokenDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

interface Props {
  data: DatevWizardData
  companyId: string
  accessId: string
  clientId: string
  setShowDisconnectModal: (value: boolean) => void
  setAuthenticated: (value: boolean) => void
  setBannerCode: (value: number) => void
  legalEntityKey: string
  clientIdKey: string
}

export const DisconnectModal = ({
  data,
  companyId,
  accessId,
  clientId,
  setShowDisconnectModal,
  setAuthenticated,
  setBannerCode,
  legalEntityKey,
  clientIdKey,
}: Props) => {
  const [
    revokeIntegrationsdatevlaudsOauthToken,
    { loading: revokingIntegrationsdatevlaudsOauthToken },
  ] = useMutation(RevokeDatevLaudsTokenDocument, {
    extractorFn: (data) =>
      data.integrationsDatevLaudsMutations.revokeIntegrationsdatevlaudsOauthToken,
  })

  const revokeTokens = async () => {
    const result = await revokeIntegrationsdatevlaudsOauthToken({
      variables: {
        accessId: accessId,
        companyId: companyId,
        clientId: clientId,
      },
    })

    const handled = handleResult(result, (_errors) => {})
    if (handled.success) {
      setShowDisconnectModal(false)
      setAuthenticated(false)
      setBannerCode(0)
      const splitLegalEntity = legalEntityKey.split('_')
      const id = splitLegalEntity[splitLegalEntity.length - 1]
      delete data.answers[legalEntityKey]
      delete data.answers[clientIdKey]
      delete data.answers[`authenticated_${legalEntityKey}`]
      data.answers[`job_uuid_${id}`] = ''
      data.answers[`request_id_${id}`] = ''
      localStorage.setItem('datev_lauds_form_data', JSON.stringify(data))
      setTimeout(() => window.location.reload(), 500)
    } else {
      app.setFlash({
        type: 'wrong',
        message: 'Error revoking tokens',
      })
    }
  }

  return (
    <Modal
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.disconnect_modal_title'
      )}
      illustration="alert"
      onClose={() => setShowDisconnectModal(false)}
      footer={
        <>
          <Button type="secondary" onClick={() => setShowDisconnectModal(false)}>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.cancel'
            )}
          </Button>
          <Button onClick={revokeTokens} disabled={revokingIntegrationsdatevlaudsOauthToken}>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.disconnect'
            )}
          </Button>
        </>
      }
    >
      <>
        <Text size="300">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.disconnect_modal_description'
          )}{' '}
          <Link.Href href={'https://apps.datev.de/tokrevui'}>here</Link.Href>.
        </Text>
      </>
    </Modal>
  )
}
